import { useState } from 'react';
import axios from 'axios';
import orbUrl from '../orbAsset';


const wordmarkUrl = "/hypseya-wordmark.png";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const field = {
  width: '100%', padding: '14px 16px',
  borderRadius: '12px', border: '1.5px solid rgba(184,211,207,0.5)',
  background: 'rgba(255,255,255,0.88)', fontSize: '0.95rem',
  color: '#333', outline: 'none', fontFamily: 'inherit',
  boxSizing: 'border-box'
};

export default function Waitlist() {
  const [form, setForm]     = useState({ name: '', email: '', intention: '' });
  const [status, setStatus] = useState('idle'); // idle | loading | success | error
  const [msg, setMsg]       = useState('');

  const handleSubmit = async () => {
    if (!form.name.trim() || !form.email.trim()) {
      setMsg('Name and email are required.'); return;
    }
    setStatus('loading');
    try {
      const res = await axios.post(`${API}/waitlist`, form);
      setStatus('success');
      setMsg(res.data.message || "You're on the list.");
    } catch {
      setStatus('error');
      setMsg('Something went wrong. Please try again.');
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(160deg,#fafbfc 0%,#f0f7f6 35%,#e8f3f1 60%,#f5f8f7 100%)',
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', padding: '40px 24px'
    }}>
      {/* Brand */}
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px', marginBottom: '40px' }}>
        <img src={orbUrl} alt="" style={{ width: '80px' }} />
        <img src={wordmarkUrl} alt="HYPSEYA" style={{ width: '160px', opacity: 0.85 }} />
      </div>

      {status === 'success' ? (
        <div style={{ textAlign: 'center', maxWidth: '340px' }}>
          <p style={{ fontFamily: "'Playfair Display',serif", fontSize: '1.4rem', color: '#1E6B68', fontStyle: 'italic', marginBottom: '12px' }}>
            You're on the list.
          </p>
          <p style={{ fontSize: '0.9rem', color: '#9AADAB', lineHeight: '1.7' }}>
            We'll be in touch when your space opens.<br />
            Whatever opened you is still working on you.
          </p>
        </div>
      ) : (
        <div style={{ width: '100%', maxWidth: '400px' }}>
          <p style={{ fontFamily: "'Playfair Display',serif", fontSize: '1.4rem', color: '#1E6B68', fontStyle: 'italic', textAlign: 'center', marginBottom: '8px' }}>
            For people doing the deeper work.
          </p>
          <p style={{ fontSize: '0.85rem', color: '#9AADAB', textAlign: 'center', lineHeight: '1.7', marginBottom: '32px' }}>
            Whatever opened you — HYPSEYA helps you bring it back.<br />
            Join the waitlist to be first in.
          </p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
            <input
              type="text"
              placeholder="Your name"
              value={form.name}
              onChange={e => setForm({ ...form, name: e.target.value })}
              style={field}
            />
            <input
              type="email"
              placeholder="Your email"
              value={form.email}
              onChange={e => setForm({ ...form, email: e.target.value })}
              style={field}
            />
            <textarea
              placeholder="What are you integrating? (optional)"
              value={form.intention}
              onChange={e => setForm({ ...form, intention: e.target.value })}
              rows={3}
              style={{ ...field, resize: 'none', lineHeight: '1.6' }}
            />

            {msg && (
              <p style={{ fontSize: '0.82rem', color: status === 'error' ? '#D9534F' : '#9AADAB', margin: 0 }}>
                {msg}
              </p>
            )}

            <button
              onClick={handleSubmit}
              disabled={status === 'loading'}
              style={{
                width: '100%', padding: '16px', borderRadius: '14px',
                background: status === 'loading' ? '#9AADAB' : '#1E6B68',
                border: 'none', color: '#fff', fontSize: '0.95rem',
                fontWeight: '600', cursor: status === 'loading' ? 'default' : 'pointer',
                letterSpacing: '0.02em', transition: 'background 0.2s'
              }}
            >
              {status === 'loading' ? 'Sending…' : 'Join the waitlist'}
            </button>

            <p style={{ fontSize: '0.72rem', color: '#B8C8C6', textAlign: 'center', margin: 0 }}>
              No spam. Unsubscribe any time. RGPD compliant.
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
